// Material calculation utilities

import { PIECE_COSTS } from '../constants';

// Piece values for material calculation (king = 0)
const MATERIAL_VALUES = Object.freeze({
  p: PIECE_COSTS.p || 1,
  n: PIECE_COSTS.n || 3,
  b: PIECE_COSTS.b || 3,
  r: PIECE_COSTS.r || 5,
  q: PIECE_COSTS.q || 9,
  k: 0
});

/**
 * Compute material values for both sides from a chess.js game board
 * 
 * @param {Object} game - A chess.js game instance
 * @returns {{ white: number, black: number }} Material values for each side
 */
export function computeMaterial(game) {
  const board = game?.board?.() || [];
  let white = 0;
  let black = 0;
  for (let r = 0; r < board.length; r++) {
    const row = board[r] || [];
    for (let c = 0; c < row.length; c++) {
      const piece = row[c];
      if (!piece) continue;
      const v = MATERIAL_VALUES[piece.type] || 0;
      if (piece.color === 'w') white += v; else black += v;
    }
  }
  return { white, black };
}

/**
 * Check if a side has any pieces on the board
 * 
 * @param {Object} game - A chess.js game instance
 * @param {string} color - 'w' or 'b'
 * @returns {boolean} True if the side has at least one piece
 */
export function hasSidePieces(game, color) {
  try {
    const board = game?.board?.() || [];
    for (let r = 0; r < board.length; r++) {
      const row = board[r] || [];
      for (let c = 0; c < row.length; c++) {
        const piece = row[c];
        if (piece && piece.color === color) return true;
      }
    }
    return false;
  } catch (_) {
    return false;
  }
}






